<template>
  <div>
    <template slot="header">显示指标数值</template>
    <div style="width:auto">
      <div class="inner">
          <ve-line :data="chartData" :settings="chartSettings" :extend="extend" v-bind="pubSetting"></ve-line>
      </div>
    </div>
  </div>
</template>

<script>
import list from '@/pages/demo/charts/list/_mixin/list.js'
export default {
  props:['tjType','datalist'],

  mixins: [
    list
  ],
  data () {
    this.chartSettings = {
      labelMap: {
        'dateTime': '日期',
        'value': '开赛数'
      },
      // legendName: {
      //   '哈哈': '访问用户 total: 10000'
      // }
    }
    this.extend = {
      //'xAxis.0.axisLabel.rotate': 45,    
      scrollbar: {
        enabled: true
      },
      series: {
        label: {
          normal: {
            show: true
          }
        }
      }
    }
    
    return {
      chartData: {
        columns: ['dateTime', 'value'],
        rows: [
           
        ]
      },
    }
  },
  watch:{
    datalist(n,o){
      this.init()
    }
  },
  methods:{
    chartDone(){
      this.$emit('chartSuccess',this.datalist)
    },
    init(){
      this.chartData.rows = this.datalist
      this.chartSettings.labelMap.value = this.datalist[0].name
      this.chartDone()
    }
  }
}
</script>

<style lang="scss" scoped>
.inner {
  position: absolute;
  top: 20px;
  right:  20px;
  bottom: 20px;
  left: 20px;
}
</style>
